import { isNil } from 'lodash';
import React, { ReactNode, useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBImage, MBImageURISource } from '@shared/components/image';
import { MBTextBody2 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { ChatDateStamp } from '../ChatDateStamp';
import { Styles } from '../styles';

interface MBBaseSystemMessageProps {
  image?: ReactNode;
  icon?: MBImageURISource;
  color?: string;
  text: string;
  date: string;
  hovering: boolean;
  isDesktop: boolean;
  paddingLeft?: number;
  style?: StyleProp<ViewStyle>;
}

/*
    This is the base system message, which is used as a template for
    all subtype specific system messages.
*/
export function MBBaseSystemMessage({
  image,
  icon,
  text,
  color,
  date,
  hovering,
  isDesktop,
  paddingLeft = 0.75,
  style,
}: MBBaseSystemMessageProps) {
  const colors = useContext(ColorThemeContext);
  const showTime = !isDesktop || hovering;
  return (
    <MBView row fullWidth paddingLeft={paddingLeft} style={[{ flexWrap: 'wrap' }, style]}>
      <View centerHorizontally centerVertically style={{ width: grid(4), height: grid(4) }}>
        {!isNil(image) && image}
        {isNil(image) && !isNil(icon) && (
          <MBImage tintColor={color} style={Styles.systemMessageIcon} source={icon} />
        )}
      </View>
      <View flex row wrap paddingTop={0.75} paddingLeft={0.5} style={{ alignItems: 'baseline' }}>
        <View style={{ maxWidth: '80%' }} marginBottom={0.5} marginRight={2}>
          <MBTextBody2 color={colors.foregroundActive}>{text}</MBTextBody2>
        </View>
        <ChatDateStamp date={date} opacity={showTime ? 1 : 0} />
      </View>
    </MBView>
  );
}
